/** ادغام کلاس‌های شرطی — بدون وابستگی خارجی */
export type ClassValue =
  | string
  | number
  | bigint
  | null
  | undefined
  | false
  | ClassValue[]
  | { [key: string]: boolean | null | undefined }

export function cn(...inputs: ClassValue[]): string {
  const out: string[] = []

  const walk = (value: ClassValue): void => {
    if (!value) return
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'bigint') {
      out.push(String(value))
      return
    }
    if (Array.isArray(value)) {
      value.forEach(walk)
      return
    }
    if (typeof value === 'object') {
      for (const key in value) {
        if (value[key]) out.push(key)
      }
    }
  }

  inputs.forEach(walk)
  return out.join(' ')
}
